import FURGAPI from './api.furg';

import { decodeHexHtmlCharCodes } from './utils';

const TOKEN_KEY = '@Auth-Token';

const _setToken = (token, params) => {
    sessionStorage.setItem(token, JSON.stringify(params));
};

const _getToken = token => {
    return JSON.parse(sessionStorage.getItem(token));
};

export const isAuthenticated = vestibular => {
    const token = _getToken(TOKEN_KEY);
    return token !== null && token[vestibular] !== undefined;
};

export const getToken = vestibular => {
    const token = _getToken(TOKEN_KEY);
    return token[vestibular]?.token;
};

export const setToken = (vestibular, token) => {
    _setToken(TOKEN_KEY, {
        [vestibular]: { token, vestibular },
    });
};

export const login = async (nr_cpf, email, vestibular) => {
    try {
        const dados = { vestibular, nr_cpf, email };
        const { token } = await FURGAPI.call('sischamamentos/Publico/identificaCandidato', dados).catch(err => {
            throw Error(decodeHexHtmlCharCodes(err));
        });
        _setToken(TOKEN_KEY, {
            [vestibular]: { token, vestibular },
        });
    } catch (err) {
        logout();
        throw err;
    }
};

export const logout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
};
